import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setParams,
  selectCrossProductParams,
} from '@stores/crossProductAction';
import {
  initialCrossProductParams,
  consumeInitialParams,
} from './crossProductInitialParams';

export function useCrossProductParams() {
  const dispatch = useDispatch();
  const existingParams = useSelector(selectCrossProductParams);
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    if (existingParams) return;

    if (initialCrossProductParams) {
      dispatch(setParams(initialCrossProductParams));
      consumeInitialParams();
    }
    processedRef.current = true;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
